/**
 * EnTeteDePanneau — le bandeau du haut d'un panneau (lot « surfaces », 01-11-2026) : la personne
 * ou la chose (sa photo, ou une icône), son nom en Almarena, un sous-titre, et les actions à
 * droite — « bratz · Ton espace perso », « Analytics de l'organisation · Général | 24 h ».
 * Une hairline à peine visible dessous, pas de bloc ; `collant` le garde en haut quand le corps
 * défile. Sur un téléphone, les actions passent dessous.
 *
 *   <EnTeteDePanneau visuel={<Tuile … />} titre="bratz" sousTitre="Ton espace perso"
 *                    actions={<Onglets … />} />
 */
import type { ReactNode } from "react";

import { cn } from "./utils";
import "./surfaces.css";

export interface EnTeteDePanneauProps {
  titre: ReactNode;
  sousTitre?: ReactNode;
  /** Une photo (`<Tuile>`, `<ChatAvatar>`, `<img>`) ou une icône — jamais une icône dans un rond décoratif. */
  visuel?: ReactNode;
  /** À droite : des onglets, des boutons, un sélecteur de période. */
  actions?: ReactNode;
  /** Reste en haut quand le corps défile (verre dépoli dessous). */
  collant?: boolean;
  /** La balise du titre. Défaut `h1`. */
  niveau?: "h1" | "h2" | "h3";
  className?: string;
}

export function EnTeteDePanneau({ titre, sousTitre, visuel, actions, collant = false, niveau: Titre = "h1", className }: EnTeteDePanneauProps) {
  return (
    <header className={cn("sf-bandeau", className)} data-collant={collant || undefined}>
      {visuel !== undefined && visuel !== null && <div className="sf-bandeau-visuel">{visuel}</div>}
      <div className="sf-bandeau-texte">
        <Titre className="sf-bandeau-titre">{titre}</Titre>
        {sousTitre !== undefined && sousTitre !== null && <div className="sf-sous-titre">{sousTitre}</div>}
      </div>
      {actions && <div className="sf-bandeau-actions">{actions}</div>}
    </header>
  );
}
